import { Injectable } from '@angular/core';
import { ICountryList } from '../../submodules/silverlight-common/lib/ts/src/interface/country.list.interface';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import UIConstants from '../../app-constants/ui-constants';
import APIURLConstants from '../../app-constants/api-url-constants';
@Injectable({
  providedIn: 'root',
})
export class CountryListService {
  private readonly countryListServiceConstants = APIURLConstants.Country_List_Service
  private readonly URL = this.countryListServiceConstants.BASE_URL;
  constructor(public http: HttpClient) {}

  getCountryList(): Observable<any> {
    return this.http.get<ICountryList[]>(this.URL);
  }
}
